(function() {
    'use strict';

    angular
        .module('uwAgenda.global')
        .directive('a', aFunction);


    /* Metronic a-Directive */
    aFunction.$inject = [];
    function aFunction() {
        var directive = {
            link: link,
            restrict: 'E'
        };
        return directive;

        function link(scope, element, attrs) {
            if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                element.on('click', function (e) {
                    e.preventDefault(); // prevent link click for above criteria
                });
            }

            // on destroy
            scope.$on('$destroy', function () {
                element.off('click');
            });
        }
    }

})();